import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function ElfsightPopup() {
  const location = useLocation();

  useEffect(() => {
    // Don't load on Get a Quote page
    if (location.pathname === '/get-a-quote') {
      return;
    }

    // Load Elfsight script
    const script = document.createElement('script');
    script.src = 'https://elfsightcdn.com/platform.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // Cleanup script on unmount
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, [location.pathname]);

  // Don't render on Get a Quote page
  if (location.pathname === '/get-a-quote') {
    return null;
  }

  return (
    <div className="elfsight-app-a8d09b4b-1f9c-47af-9c95-257e6e1aa6a7" data-elfsight-app-lazy></div>
  );
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <AppRoutes />
        <ElfsightPopup />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
